class NavLinkToggle {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-scope="navbar-desktop"]',
            link: '.nav-link'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
        this.initEventListeners();
	}

    initEventListeners() {
        this.$scope.on('click', this.config.link, (e) => this.toggleMenu(e));
    }

    toggleMenu(e) {
        let $target = $(e.currentTarget);
        let $active = this.$scope.find(this.config.link + '.active');
        $active.removeClass('active');
        $target.addClass('active');
    }
}

export default new NavLinkToggle;
